import React from 'react'
import styles from './initials.module.scss'
export default function Initials({initials, width, height, background, color}) {
  return (
    <div style={{width, height, background, color}} className={styles.initials}>
      {initials}
    </div>
  )
}
